import React from 'react';

interface StateModel {
  page: string[];
  loading: boolean;
  menuCollapsed: boolean;
  attributesCollapsed: boolean;
}

interface MethodsModel {
  setStateAsync?: (state: any) => Promise<any>;
  setPage?: (page: string[]) => void;
  setLoader?: (loading: boolean) => void;
  setMenuCollapsed?: (menuCollapsed: boolean) => void;
  setAttributesCollapsed?: (attributesCollapsed: boolean) => void;
}

const MethodsContext = React.createContext({} as MethodsModel);
const StateContext = React.createContext({} as StateModel);
export { MethodsContext, StateContext };
export type { MethodsModel, StateModel };
